module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_points3DList_FLAGGED.7fc46db0.bin";